{
  document.querySelectorAll('.video-component--play-button').forEach(el => {
    el.addEventListener('click', e => {
      const image = el.closest('.video-component').querySelector('.video-component--preview-image')
      const iframe = el.closest('.video-component').querySelector('iframe[data-src]')
      let src = iframe.getAttribute('data-src')
      if(src.includes('autoplay=0')) {
        src = src.replace(/autoplay=0/, 'autoplay=1')
      } else {
        src += src.includes('?') ? '&autoplay=1' : '?autoplay=1'
      }
      iframe.src = src
      image.remove()
      el.remove()
    })
  })
}